import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, filter, map, of, tap } from 'rxjs';
import { SessionActions } from './session.actions';
import { SessionFacade } from './session.facade';
import { isDefined } from '@lyceo/shared/util';
import { AuthFacade, AuthService } from '@lyceo/shared/auth/data-access';
import { ApplicationFacade } from '@lyceo/shared/data-access';
import { SessionService } from '../../api/session.service';

@Injectable()
export class SessionEffects {
  private readonly actions$: Actions = inject(Actions);
  private readonly sessionService: SessionService = inject(SessionService);
  private readonly sessionFacade: SessionFacade = inject(SessionFacade);
  private readonly authService: AuthService = inject(AuthService);
  private readonly authFacade: AuthFacade = inject(AuthFacade);
  private readonly applicationFacade: ApplicationFacade =
    inject(ApplicationFacade);

  public loadSession$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(SessionActions.loadSession),
      map(() => this.sessionFacade.directLinkParam()),
      filter(isDefined),
      exhaustMap((directLinkParam) =>
        this.sessionService.startSessionByDirectLink(directLinkParam).pipe(
          map((session) =>
            SessionActions.loadSessionSuccess({
              session,
            }),
          ),
          catchError((error) =>
            of(
              SessionActions.loadSessionFailure({
                error,
              }),
            ),
          ),
        ),
      ),
    );
  });

  public loadSessionFailure$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(SessionActions.loadSessionFailure),
        tap((action) => {
          if (
            [401, 403].includes(action.error.status) &&
            !this.authFacade.isAuthenticated()
          ) {
            this.authService.stateLogin(
              `start/${this.sessionFacade.directLinkParam()}`,
            );
          } else {
            this.applicationFacade.showToaster({
              type: 'error',
              message:
                'Er is iets fout gegaan bij het starten van een sessie via deze link.',
            });
          }
        }),
      );
    },
    { dispatch: false },
  );
}
